import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  discountListParams,
  discountListQueryOptions,
  discountListSearchSchema,
  DiscountsPage,
} from '@/features/discounts';

export const Route = createFileRoute('/_authed/_active/s/$storeId/discounts/')({
  staticData: { tours: ['discounts.list'] },
  validateSearch: discountListSearchSchema,
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'discounts.read');
  },
  loader: async ({ context, params, deps, cause }) => {
    const prefetch = context.queryClient
      .query({
        ...discountListQueryOptions(params.storeId, discountListParams(deps)),
        staleTime: 'static',
      })
      .catch(() => undefined);
    // Filter, sort and page changes on the list must not wait for the fetch, or a second pick in
    // the filter would build on the stale URL. The page's own query shows the previous rows.
    if (cause !== 'stay') await prefetch;
  },
  component: DiscountsPage,
});
